module.exports = __webpack_public_path__ + "static/bubble-with-negative-values-2cee12d304ae85285a390f39ec3c5b10.png";